const enum AvatarVariant {
  default = 'default',
}

export default AvatarVariant
